var common = {
  black: '#000',
  white: '#fff'
};
export default common;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/colors/common.js
// module id = 443
// module chunks = 9